import { createAction, props, union } from '@ngrx/store';

import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { StatsConnectI } from 'src/app/api/stats-connect/stats-connect.result.int';
import { StatsConnectQueryI } from 'src/app/api/stats-connect/stats-connect.query.int';

export const error = createAction('[Stats / Connect] Error', props<{ error: SharedErrorObjectI }>());
export const load = createAction('[Stats / Connect] Load', props<{
    query: StatsConnectQueryI;
}>());
export const received = createAction('[Stats / Connect] Received', props<{
    result: StatsConnectI;
}>());
export const reset = createAction('[Stats / Connect] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
